export default "__VITE_ASSET__CTNCjM0r__"